import { render, staticRenderFns } from "./AddSchema.vue?vue&type=template&id=702acc9d"
import script from "./AddSchema.vue?vue&type=script&lang=ts"
export * from "./AddSchema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports